import React, { useEffect, useState } from 'react'
import Card from '../../../../common/card/Card'
import { useParams } from 'react-router-dom'
import { QueryClient, useQuery } from '@tanstack/react-query'
import { performRequest } from '../../../../common/utils'
import Loader from '../../../../common/loader/Loader'
import useLicenseTable from '../context/LicenseTableContext'
import LicensePresetsTable from './LicensePresetsTable'


const LicensePresets = ({ teamType, refetchTeamData }) => {

  const params = useParams()
  const teamId = params.team_id
  const [ responseMessage, setResponseMessage ] = useState('')
  const { setRefetchLicensePresets, setSelectedLicensePreset, setSelectedModal, setSelectedBulkLicense } = useLicenseTable()

  const queryClient = new QueryClient()

  const {
    isLoading,
    isPending,
    isFetching,
    isError,
    error,
    refetch,
    data } = useQuery({
      queryKey: ['get_org_license_presets'],
      queryFn: requestOrgLicenses,
      refetchOnWindowFocus: false
    }, queryClient)

    async function requestOrgLicenses() {
        const {
            group_dashboard: { nonce, base }
        } = window
        let url = base + 'membersync/licensing/v1/org/' + teamId + '/presets'

        const res = await fetch(`${url}`, {
            method: 'POST',
            body: JSON.stringify({
                type: 'license'
            }),
            headers: {
              'X-WP-Nonce': nonce,
              'Content-type': "application/json"
            },
            credentials: 'same-origin',
            processData: false,
            contentType: false,
        })

        if ( !res.ok ) throw Error(res.statusText)

        const resultJSON = await res.json()
        return resultJSON.response
    }

  useEffect(() => {
    setRefetchLicensePresets(() => refetch)
    setSelectedLicensePreset('')
    setSelectedModal('')
    setSelectedBulkLicense('')
  }, [ refetch ])

  if( isLoading || isPending || isFetching ){
    return (
      <Loader type='spinner-dual-ring'/>
    )
  }

  if( isError ){
    return (
      <Card> 
        <strong> { error.message } </strong> 
      </Card>
    )
  }

  return (
    <>
      {
        responseMessage && responseMessage !== ''
        ? <Card> 
            <strong>{ responseMessage }</strong> 
          </Card>
        : data.length !== 0 && 
          <LicensePresetsTable licensePresetsData={ data } refetchPresets={ refetchTeamData } />
      }
    </>
  )
}

export default LicensePresets
